import React from 'react';
import { Link } from 'react-router-dom';
import Sentry from './SentryBugReporting';
import * as Validations from './validations';
import * as Formatters from './formatters';
import * as Exceptions from './exceptions';
import * as Breakpoints from './breakpoints';
import * as GridNumbers from './grid';
import * as ToolPermissions from './ToolPermissions';
import * as BrandHelper from './BrandHelper';

// get link props base on if it's external
const getLinkProps = (url, external) => {
  if (!url) {
    return { as: 'a' };
  }

  return external ? { as: 'a', href: url, target: '_blank' } : { to: url };
};

// use this when link is not styled component
// eslint-disable-next-line react/prop-types
const LinkComponent = ({ url, external, children, ...props }) => {
  // eslint-disable-next-line no-unused-vars
  const { as, to, ...rest } = getLinkProps(url, external);
  return external ? (
    <a {...rest} {...props}>
      {children}
    </a>
  ) : (
    <Link to={to} {...rest} {...props}>
      {children}
    </Link>
  );
};

export {
  getLinkProps,
  ToolPermissions,
  LinkComponent,
  Sentry,
  Validations,
  Formatters,
  Exceptions,
  Breakpoints,
  GridNumbers,
  BrandHelper
};
